<template>
    <div v-if="form">
        <div class="flex justify-between items-center mb-3">
            <h2 class="text-xl text-gray-800">Update Profile</h2>
        </div>
        <div class="bg-white shadow-lg p-6 rounded-lg border border-gray-300">
            <div>
                <my-select
                    v-model="form.location"
                    name="location"
                    :error="form.errors.get('location')"
                    label="Location"
                    :options="countries"
                    class="mb-4"
                    placeholder="Choose a country"
                />

                <my-textarea
                    v-model="form.bio"
                    name="bio"
                    :error="form.errors.get('bio')"
                    label="Brief Bio"
                    class="mb-4 h-48"
                    placeholder="Your brief bio (not more than 500 characters)"
                />

                <hr class="my-4" />
                <div class="flex justify-between">
                    <my-button :loading="submitting" class="btn btn-primary" @click="submitForm">
                        <i class="fa fa-save"></i> Update Details
                    </my-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '../forms/form';

export default {
    props: {
        userId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            form: null,
            profile: null,
            submitting: false,
            countries: []
        };
    },

    mounted() {
        this.fetchCountries();

        axios.get(`/api/users/${this.userId}/profile`).then(response => {
            this.profile = response.data.data;

            this.initForm();
        });
    },

    methods: {
        initForm() {
            this.form = new Form({
                location: this.profile.location,
                bio: this.profile.bio
            });
        },

        fetchCountries() {
            axios.get('/api/countries').then(response => {
                this.countries = _.keyBy(response.data.data, value => value);
            });
        },

        submitForm() {
            this.submitting = true;

            this.form
                .post(`/api/profile/${this.profile.id}`)
                .then(response => {
                    this.profile = response.data.data;
                    flash.success();
                    this.submitting = false;
                })
                .catch(() => {
                    flash.error();
                    this.submitting = false;
                })
                .finally(() => (this.submitting = false));
        }
    }
};
</script>
